window.$ = window.jQuery = require('jquery');
// window.Axios = require('axios')


require('./pages/custom');
